import { load as loadRecaptcha } from "recaptcha-v3";
import "./style.css";

import Api from "@/components/Api";

export default class ContactForm {
  static selector = ".contact-us";

  constructor(block) {
    this.block = block;
    this.form = block.querySelector(".contact-us__form");

    const fileInputs = this.form.querySelectorAll("input[type=file]");
    const choiceCheckboxes = this.form.querySelectorAll(
      ".contact-us__form__preferences__choices input[type=checkbox]"
    );
    for (const input of fileInputs) {
      input.addEventListener("input", this.getOnInput(fileInputs));
    }
    for (const input of choiceCheckboxes) {
      input.addEventListener("input", this.getOnInput(choiceCheckboxes));
    }

    this.form.addEventListener("input", this.onInputForm);
    this.form.addEventListener("invalid", this.onInvalidForm, true);

    this.submitButton = this.form.querySelector("button");
    this.submitButton.addEventListener("click", this.onSubumitButtonClick);

    const positionName = document.getElementById("position-name");
    if (!!positionName) {
      positionName.addEventListener("change", function () {
        if (positionName.value == "Other" || positionName.value == "أخرى") {
          positionName.style.display = "none";
          document.getElementById("position-name-other").style.display =
            "block";
          document.getElementById("reset-link").style.display = "inline-block";
          document
            .getElementById("position-name-other")
            .setAttribute("required", "required");

          var position_name_error = document.getElementById("position-name-other").nextElementSibling;
          position_name_error.style.display = 'block';
        } else {
          document.getElementById("position-name-other").style.display = "none";
          document.getElementById("reset-link").style.display = "none";
          positionName.style.display = "block";
          document.getElementById("position-name-other").value = "";
          document
            .getElementById("position-name-other")
            .removeAttribute("required");

          var position_name_error = document.getElementById("position-name-other").nextElementSibling;
          position_name_error.style.display = 'none';
        }
      });

      if (document.getElementById("position-reset-link") != null) {
        document
          .getElementById("position-reset-link")
          .addEventListener("click", function () {
            document.getElementById("position-name-other").style.display =
              "none";
            document.getElementById("reset-link").style.display = "none";
            positionName.style.display = "block";
            document.getElementById("position-name-other").value = "";
            positionName.selectedIndex = "0";
            document
              .getElementById("position-name-other")
              .removeAttribute("required");

            var position_name_error = document.getElementById("position-name-other").nextElementSibling;
            position_name_error.style.display = 'none';
          });
      }
    }

    this.recaptchaSiteKey = this.form.dataset.recaptcha;
    this.recaptchaResponseInput = this.form.querySelector(
      "input[name=recaptchaResponse]"
    );

    this.isRecaptcha = !!this.recaptchaSiteKey && !!this.recaptchaResponseInput;
  }

  onSubumitButtonClick = (e) => {
    e.preventDefault();
    this.submitButton.classList.toggle("disabled", true);
    this.sendForm();
  };

  getOnInput = (inputs) => {
    return (e) => {
      const currentInput = e.currentTarget;

      const allowMultiple = currentInput.type === "checkbox";
      const required = !!(currentInput.type === "checkbox"
        ? currentInput.checked
        : currentInput.value.length);

      for (const input of inputs) {
        input.required = !required;
        input.disabled = !allowMultiple && required;
        this.setValidity(input.parentNode, true);
      }

      currentInput.required = required;
      currentInput.disabled = !allowMultiple && !required;
    };
  };

  setStatus = (success, message) => {
    const status = this.form.querySelector(".contact-us__form__status");
    const info = status.querySelector(".contact-us__form__status__message");
    //const sentMessage = document.getElementById("message_div");
    //const sentMessage = this.form.querySelector(".sentMessage");
    const sentMessage = this.form.querySelector(".message_div");
    sentMessage.style.display = "block";
    //status.classList.add(success ? "sent" : "failed");
    sentMessage.classList.remove("success_message");
    sentMessage.classList.remove("failed_message");
    if (success) {
      sentMessage.classList.add("success_message");
      this.form.reset();
    } else {
      sentMessage.classList.add("failed_message");
    }
    //document.getElementById("message_content").innerHTML = message;
    this.form.querySelector(".message_content").innerHTML = message;
    setTimeout(function () {
      sentMessage.style.display = "none";
    }, 10000);
  };

  setValidity = (block, valid) => {  
    const input = block.querySelector("input");
    const error = block.querySelector(".error-message");

    const errorClass = "error";
    const emptyFieldMessage = window.saee.copy["You have to fill this field"];
    //const defaultErrorMessage = window.saee.copy["Invalid field"];
    const defaultErrorMessage = '';

    let errorMessage = input.validationMessage || defaultErrorMessage;


    const variant = document.querySelector("form.contact-us__form input[name='variant']");
    if (variant.value==='election-list') {

      if ( errorMessage==='Please match the requested format.') {
        errorMessage = input.title;
      } else if ( errorMessage!=='' && input.type==='email' ) {
        errorMessage = 'الرجاء كتابة عنوان بريد إلكتروني صالح'
      }
    }
    

    if (!input.value.trim()) {
      errorMessage = emptyFieldMessage;
      if (variant.value==='election-list') {
        errorMessage = 'عليك ملء هذا الحقل'; // todo: for change
      }
    }

    block.classList.remove(errorClass);
    if (!valid || errorMessage!='') {
      block.classList.add(errorClass);
    }

    if (error) {
      error.textContent = errorMessage;
    }
  };

  onInputForm = async (e) => {
    e.preventDefault();
    this.setValidity(e.target.parentNode, true);
  };

  onInvalidForm = async (e) => {
    e.preventDefault();
    this.setValidity(e.target.parentNode, false);
  };

  sendForm = async () => {
    const valid = this.form.checkValidity();
    const variant = document.querySelector("form.contact-us__form input[name='variant']");
    var successTextMessage = "The message has been sent successfully";

    if (variant.value==='election-list') {
      successTextMessage = "شكراً لك! تم إرسال النموذج بنجاح";
    }

    if (valid) {

      if (variant.value==='membership-enquiry') {
        successTextMessage = 'The email is already registered for membership. We have recorded the details you have shared. Our admin will contact you separately. ';
      }
      const successText = successTextMessage;
      const failureText = "Message could not be sent, please try again later";

      if (this.isRecaptcha) {
        const recaptcha = await loadRecaptcha(this.recaptchaSiteKey, {
          useRecaptchaNet: true,
          autoHideBadge: true,
        });
        const token = await recaptcha.execute("submit");
        this.recaptchaResponseInput.value = token;
      }

      const payload = new FormData(this.form);

      try {
        const response = await Api.contactUs(payload);

        const success = response === true;
        //const message = window.saee.copy[response === true ? successText : failureText];
        
        const message = successText;

        this.setStatus(success, message);
      
      } catch (err) {
        this.setStatus(false, err.message);
      }
      
    }

    this.submitButton.classList.toggle("disabled", false);
  };
}
